<template>
  <div class="file" v-if="file">
    <file-icon width="30" height="33"></file-icon>
    <div class="file-description">
      <span :title="file.filename" class="file-name">{{ file.filename }}</span>
      <small>{{ file.size | convertSize }} kb</small>
    </div>
    <button class="remove-file" type="button" @click="removeFile()">
      <close-icon width="8px" height="8px" weight="light"></close-icon>
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import FileIcon from "@/components/icons/FileIcon";
import CloseIcon from "@/components/icons/CloseIcon";

export default {
  name: "ExcangeCopyFile",
  props: {
    file: {
      required: true
    },
    exchangeCopyId: {
      required: true
    },
    index: {
      required: true
    }
  },
  components: {
    FileIcon,
    CloseIcon
  },
  methods: {
    ...mapActions("common", ["setLoading", "showModal"]),
    removeFile() {
      this.$emit("removeFileFromExchangeCopy", {
        index: this.index,
        fileId: this.file.id,
        exchangeId: this.exchangeCopyId
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../assets/styles/variables";

.file {
  display: flex;
  align-items: stretch;
  font-size: 14px;
  margin-bottom: 10px;
  svg {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
    flex-shrink: 0;
  }
  .file-description {
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .file-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .progress-bar {
    width: 100%;
    height: 4px;
    background: $middle-gray;
  }
  .remove-file {
    background: $middle-gray;
    border: 1px solid #979797;
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    padding: 0;
    margin: 3px -14px 3px 3px;
    svg {
      margin: 0;
    }
  }
}
small {
  color: $placeholder-color;
}
</style>
